import { render } from "./AuctionComponent.vue?vue&type=template&id=0a8d8daa"
import script from "./AuctionComponent.vue?vue&type=script&lang=js"
export * from "./AuctionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/auctions/AuctionComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a8d8daa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a8d8daa', __exports__)) {
    console.log('reload')
    api.reload('0a8d8daa', __exports__)
  }
  
  module.hot.accept("./AuctionComponent.vue?vue&type=template&id=0a8d8daa", () => {
    console.log('re-render')
    api.rerender('0a8d8daa', render)
  })

}


export default __exports__